// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"Breadcrumb_Breadcrumb__6FYrT","Title":"Breadcrumb_Title__+O0oZ","Divider":"Breadcrumb_Divider__7z5V+"};